import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";

import { Page, Seg } from "@/components/ui";
import { CardForm } from "@/tarjetas/CardForm";
import { CardGrid } from "@/tarjetas/CardGrid";

type Mode = "formulario" | "tabla";

/**
 * Capturing cards by hand, in either of two modes: the form, one card at a
 * time with every field checked as it is filled in, or the table, many at
 * once the way a sheet is filled — and pasted into from Excel.
 *
 * The mode is in the URL, so a seller who works in the table comes back to it.
 */
export function CapturaTarjetas() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const mode: Mode = params.get("modo") === "tabla" ? "tabla" : "formulario";

  return (
    <Page
      title={t("cards.captureTitle")}
      subtitle={
        <Link to="/tarjetas" className="text-brand-700">
          {t("cards.backToList")}
        </Link>
      }
      actions={
        <Seg<Mode>
          name="capture-mode"
          value={mode}
          onChange={(next) => setParams(next === "tabla" ? { modo: "tabla" } : {})}
          options={[
            { value: "formulario", label: t("cards.modeForm") },
            { value: "tabla", label: t("cards.modeGrid") },
          ]}
        />
      }
    >
      {mode === "tabla" ? <CardGrid /> : <CardForm />}
    </Page>
  );
}
